var render, staticRenderFns
import script from "./accountingDetail.vue?vue&type=script&lang=js&"
export * from "./accountingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a223846",
  null
  
)

export default component.exports